import { render, staticRenderFns } from "./jiegou.vue?vue&type=template&id=0d4ad2ca&scoped=true&"
import script from "./jiegou.vue?vue&type=script&lang=js&"
export * from "./jiegou.vue?vue&type=script&lang=js&"
import style0 from "./jiegou.vue?vue&type=style&index=0&id=0d4ad2ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4ad2ca",
  null
  
)

export default component.exports